import { CVTemplate } from '../types';

export const CV_TEMPLATES: CVTemplate[] = [
  {
    id: 'template1',
    name: 'Moderno Ejecutivo',
    description: 'Diseño limpio y profesional',
    image: '/design/cvmaker_01.jpg',
    category: 'modern',
    tags: ['moderno', 'profesional', 'ejecutivo'],
    defaultColor: '#4B6A9B',
    sections: {
      photo: { x: 0, y: 0, width: 350, height: 1485 },
      header: { x: 0, y: 0, width: 350, height: 200 },
      contact: { x: 63, y: 220, width: 224, height: 150 },
      moreInfo: { x: 73, y: 400, width: 204, height: 150 },
      languages: { x: 73, y: 600, width: 204, height: 150 },
      skills: { x: 73, y: 800, width: 204, height: 150 },
      about: { x: 405, y: 280, width: 700, height: 150 },
      experience: { x: 405, y: 450, width: 700, height: 300 },
      education: { x: 405, y: 920, width: 700, height: 200 }
    }
  },
  {
    id: 'template2',
    name: 'Diseño Ejecutivo Verde',
    image: '/design/cvmaker_02.jpg',
    category: 'masculino',
    tags: ['ejecutivo', 'negocios', 'formal'],
    description: 'Estilo ejecutivo perfecto para roles de negocios y gestión',
    defaultColor: '#2D6E5A',
    sections: {
      photo: { x: 0, y: 0, width: 350, height: 1485 },
      header: { x: 0, y: 0, width: 350, height: 200 },
      contact: { x: 63, y: 220, width: 224, height: 150 },
      moreInfo: { x: 73, y: 400, width: 204, height: 150 },
      languages: { x: 73, y: 600, width: 204, height: 150 },
      skills: { x: 73, y: 800, width: 204, height: 150 },
      about: { x: 405, y: 280, width: 700, height: 150 },
      experience: { x: 405, y: 450, width: 700, height: 300 },
      education: { x: 405, y: 920, width: 700, height: 200 }
    }
  },
  {
    id: 'template3',
    name: 'Diseño Elegante Dorado',
    image: '/design/cvmaker_03.jpg',
    category: 'femenino',
    tags: ['elegante', 'moderno', 'sofisticado'],
    description: 'Diseño elegante con detalles dorados para un toque sofisticado',
    defaultColor: '#B8860B',
    sections: {
      photo: { x: 0, y: 0, width: 350, height: 1485 },
      header: { x: 0, y: 0, width: 350, height: 200 },
      contact: { x: 63, y: 220, width: 224, height: 150 },
      moreInfo: { x: 73, y: 400, width: 204, height: 150 },
      languages: { x: 73, y: 600, width: 204, height: 150 },
      skills: { x: 73, y: 800, width: 204, height: 150 },
      about: { x: 405, y: 280, width: 700, height: 150 },
      experience: { x: 405, y: 450, width: 700, height: 300 },
      education: { x: 405, y: 920, width: 700, height: 200 }
    }
  },
  {
    id: 'template4',
    name: 'Diseño Pastel Rosa',
    image: '/design/cvmaker_04.jpg',
    category: 'femenino',
    tags: ['creativo', 'moderno', 'suave'],
    description: 'Diseño suave y elegante con tonos pastel',
    defaultColor: '#DB7093',
    sections: {
      photo: { x: 0, y: 0, width: 350, height: 1485 },
      header: { x: 0, y: 0, width: 350, height: 200 },
      contact: { x: 63, y: 220, width: 224, height: 150 },
      moreInfo: { x: 73, y: 400, width: 204, height: 150 },
      languages: { x: 73, y: 600, width: 204, height: 150 },
      skills: { x: 73, y: 800, width: 204, height: 150 },
      about: { x: 405, y: 280, width: 700, height: 150 },
      experience: { x: 405, y: 450, width: 700, height: 300 },
      education: { x: 405, y: 920, width: 700, height: 200 }
    }
  },
  {
    id: 'template5',
    name: 'Diseño Minimalista Verde',
    image: '/design/cvmaker_05.jpg',
    category: 'femenino',
    tags: ['minimalista', 'elegante', 'natural'],
    description: 'Diseño limpio y moderno con tonos verdes suaves',
    defaultColor: '#8FBC8F',
    sections: {
      photo: { x: 0, y: 0, width: 350, height: 1485 },
      header: { x: 0, y: 0, width: 350, height: 200 },
      contact: { x: 63, y: 220, width: 224, height: 150 },
      moreInfo: { x: 73, y: 400, width: 204, height: 150 },
      languages: { x: 73, y: 600, width: 204, height: 150 },
      skills: { x: 73, y: 800, width: 204, height: 150 },
      about: { x: 405, y: 280, width: 700, height: 150 },
      experience: { x: 405, y: 450, width: 700, height: 300 },
      education: { x: 405, y: 920, width: 700, height: 200 }
    }
  },
  {
    id: 'template6',
    name: 'Diseño Gradiente Índigo',
    image: '/design/cvmaker_06.jpg',
    category: 'masculino',
    tags: ['moderno', 'tecnológico', 'innovador'],
    description: 'Diseño moderno con gradientes y efectos de vidrio',
    defaultColor: '#4B0082',
    sections: {
      photo: { x: 0, y: 0, width: 350, height: 1485 },
      header: { x: 0, y: 0, width: 350, height: 200 },
      contact: { x: 63, y: 220, width: 224, height: 150 },
      moreInfo: { x: 73, y: 400, width: 204, height: 150 },
      languages: { x: 73, y: 600, width: 204, height: 150 },
      skills: { x: 73, y: 800, width: 204, height: 150 },
      about: { x: 405, y: 280, width: 700, height: 150 },
      experience: { x: 405, y: 450, width: 700, height: 300 },
      education: { x: 405, y: 920, width: 700, height: 200 }
    }
  },
  {
    id: 'template7',
    name: 'Diseño Circular Turquesa',
    image: '/design/cvmaker_07.jpg',
    category: 'femenino',
    tags: ['creativo', 'dinámico', 'moderno'],
    description: 'Diseño único con elementos circulares y gradientes suaves',
    defaultColor: '#40E0D0',
    sections: {
      photo: { x: 0, y: 0, width: 350, height: 1485 },
      header: { x: 0, y: 0, width: 350, height: 200 },
      contact: { x: 63, y: 220, width: 224, height: 150 },
      moreInfo: { x: 73, y: 400, width: 204, height: 150 },
      languages: { x: 73, y: 600, width: 204, height: 150 },
      skills: { x: 73, y: 800, width: 204, height: 150 },
      about: { x: 405, y: 280, width: 700, height: 150 },
      experience: { x: 405, y: 450, width: 700, height: 300 },
      education: { x: 405, y: 920, width: 700, height: 200 }
    }
  },
  {
    id: 'template8',
    name: 'Diseño Minimalista Neutro',
    image: '/design/cvmaker_07.jpg',
    category: 'masculino',
    tags: ['minimalista', 'tipográfico', 'elegante'],
    description: 'Diseño sofisticado centrado en la tipografía y espacios limpios',
    defaultColor: '#696969',
    sections: {
      photo: { x: 0, y: 0, width: 350, height: 1485 },
      header: { x: 0, y: 0, width: 350, height: 200 },
      contact: { x: 63, y: 220, width: 224, height: 150 },
      moreInfo: { x: 73, y: 400, width: 204, height: 150 },
      languages: { x: 73, y: 600, width: 204, height: 150 },
      skills: { x: 73, y: 800, width: 204, height: 150 },
      about: { x: 405, y: 280, width: 700, height: 150 },
      experience: { x: 405, y: 450, width: 700, height: 300 },
      education: { x: 405, y: 920, width: 700, height: 200 }
    }
  }
];

export const TEMPLATE_CATEGORIES = [
  {
    id: 'masculino',
    name: 'Masculino',
    description: 'Diseños profesionales con estilo masculino',
    icon: 'UserCircle2'
  },
  {
    id: 'femenino',
    name: 'Femenino',
    description: 'Diseños elegantes con estilo femenino',
    icon: 'UserRound'
  }
];